var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoldFid = function SvgGoldFid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D7B97C",
    fillRule: "evenodd",
    d: "M4.853 6A2.353 2.353 0 0 0 2.5 8.353v15.294C2.5 24.947 3.553 26 4.853 26h23.53c1.299 0 2.352-1.053 2.352-2.353V8.353c0-1.3-1.053-2.353-2.353-2.353z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    fillRule: "evenodd",
    d: "M15.921 16.007c1.008 3.812-.014 5.299-.421 5.993 1.053-1.1 2.638-3.57 1.953-6.166-.898-3.4-.445-4.858.229-5.834-2.369 2.553-2.112 4.68-1.76 6.007",
    clipRule: "evenodd"
  })));
};
export default SvgGoldFid;